import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get, isEmpty } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';
import Section from '../Section';
import { loadTexts } from '../../../../config/texts';

import { updateSupport } from '../../actions';
import { fetchUser } from '../../../auth/actions';

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing.unit * 2,
  },
  textField: {
    marginBottom: theme.spacing.unit,
  },
});
const TEXT_KEY = "organization";

class Support extends React.Component {
  state = {
    email: get(this, 'props.organization.supportEmail') || '',
    tutorEmail: get(this, 'props.organization.tutorSupportEmail') || '',
    phone: get(this, 'props.organization.supportPhone') || '',
    channel: isEmpty(get(this, 'props.organization.supportChannels'))
      ? '' : get(this, 'props.organization.supportChannels')[0],
    texts: loadTexts(TEXT_KEY, this.props.locale)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedOrganization !== this.props.selectedOrganization) {
      this.setState({
        email: get(this, 'props.organization.supportEmail') || '',
        tutorEmail: get(this, 'props.organization.tutorSupportEmail') || '',
        phone: get(this, 'props.organization.supportPhone') || '',
        channel: isEmpty(get(this, 'props.organization.supportChannels'))
          ? '' : get(this, 'props.organization.supportChannels')[0],
      });
    }
  }

  _onCancel = () => {
    this.setState({
      email: get(this, 'props.organization.supportEmail') || '',
      tutorEmail: get(this, 'props.organization.tutorSupportEmail') || '',
      phone: get(this, 'props.organization.supportPhone') || '',
      channel: isEmpty(get(this, 'props.organization.supportChannels'))
        ? '' : get(this, 'props.organization.supportChannels')[0],
    });
  };

  _onSave = async () => {
    const { email, tutorEmail, phone, channel } = this.state;
    await this.props.updateSupport({
      organization: this.props.selectedOrganization,
      email,
      tutorEmail,
      phone,
      channels: [channel],
    })
    this.props.fetchUser();
  };

  _onChange = event => {
    this.setState({ checked: event.target.checked });
  };

  render() {
    const { email, tutorEmail, phone, channel, texts: { label } } = this.state;
    const { classes, organization } = this.props;

    const orgChannel = isEmpty(get(organization, 'supportChannels'))
      ? '' : get(organization, 'supportChannels')[0];

    const disabled =
      (get(organization, 'supportEmail') || '') === (email || '')
      && (get(organization, 'tutorSupportEmail') || '') === (tutorEmail || '')
      && (get(organization, 'supportPhone') || '') === (phone || '')
      && orgChannel === (channel || '');

    return (
      <Section
        onCancel={this._onCancel}
        onSave={this._onSave}
        saveDisabled={disabled}
        cancelDisabled={false}
      >
        <div className={classes.container}>
          <TextField
            id="email"
            label={label.support_email}
            value={email}
            onChange={event => this.setState({ email: event.target.value })}
            type="email"
            className={classes.textField}
          />
          <TextField
            id="tutor_email"
            label={label.tutor_support_email}
            value={tutorEmail}
            onChange={event => this.setState({ tutorEmail: event.target.value })}
            type="email"
            className={classes.textField}
          />
          <TextField
            id="phone"
            label={label.support_phone}
            value={phone}
            onChange={event => this.setState({ phone: event.target.value })}
            type="tel"
            className={classes.textField}
          />
          <TextField
            id="channels"
            label={label.support_channel}
            value={channel}
            onChange={event => this.setState({ channel: event.target.value })}
            className={classes.textField}
          />
        </div>
      </Section>
    );
  }
}

export default compose(
  withStyles(styles, { name: 'Support' }),
  connect(
    state => {
      const selectedOrganization = get(state, 'auth.selectedOrganization');
      const organizations = get(state, 'auth.data.user.organizations') || [];
      return {
        selectedOrganization,
        organization: organizations.find(o => o._id === selectedOrganization),
        locale: state.appState.locale
      };
    },
    dispatch => ({
      updateSupport: params => dispatch(updateSupport(params)()),
      fetchUser: params => dispatch(fetchUser(params)()),
    }))
)(Support);



// WEBPACK FOOTER //
// ./src/modules/organization/cards/Support/index.js